document.addEventListener("DOMContentLoaded", () => {
  const autoplay = $(".slideshow-module").attr("status");
  const time = $(".slideshow-module").attr("time") * 1000;

  var SlideshowSwiper = new Swiper(".slideshow-module", {
    cssMode: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: autoplay == 'true' ? { delay: time, disableOnInteraction: true,} : false
  });
  
});
